import React, { useState, useEffect } from "react"
import '../../assets/css/views/activities/posLayout.css'
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, ButtonGroup, TextArea, Card, RadioButtons, RadioButton, IconChevronDown } from "@veneer/core";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import BackButton from "../../features/path/backButton";
import posLayoutService from "../../services/agendaApi/posLayout.service";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { IPosLayoutCategory, IPosLayoutDto, IPosLayoutField, IPosLayoutSubCategory } from "../../models/dto/agendaApi/IPosLayoutDto";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { IPosLayoutIn } from "../../models/input/agendaApi/IPosLayoutIn";




export default function PosLayout() {

  const params = useParams();
  const [t] = useTranslation("global");
  const languageId: any = useSelector((state: RootState) => state.languageId);
  type SelectValue = number | string | boolean; //CHECK
  const navigate = useNavigate();

  //Shows 
  const [showModalSubmitConfirmation, setShowModalSubmitConfirmation] = useState(false);
  const [showModalDetails, setShowModalDetails] = useState(false);



  //Disables
  const [saveButtonDisable, setSaveButtonDisable] = useState(true);


  //Data
  const [posLayoutData, setPosLayoutData] = useState<IPosLayoutIn[]>([]);
  const [categories, setCategories] = useState<IPosLayoutCategory[]>([]);
  const [subcategories, setSubcategories] = useState<IPosLayoutSubCategory[]>([]);
  const [fields, setFields] = useState<IPosLayoutField[]>([]);
  const [details, setDetails] = useState<string>('');
  const [selectedToDetails, setSelectedToDetails] = useState<string>('');


  const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
  const [activityId, setActivityId] = useState(NaN);


  useEffect(() => {
    getPosLayoutTypeByCategories()
    let id = Number(params.id);
    let activityId = Number(params.activityId);
    setActivityId(id)
    setAppointmentActivityId(activityId);
  }, [])

  useEffect(() => {
    setPosLayoutData([]);
    setCategories([]);
    getPosLayoutTypeByCategories();
  }, [languageId])

  useEffect(() => {
    if (posLayoutData.length > 0) {
      setSaveButtonDisable(false)
    } else {
      setSaveButtonDisable(true)
    }

  }, [posLayoutData])

  const getPosLayoutTypeByCategories = () => {
    posLayoutService.getPosLayoutTypeByCategories(languageId.value)
      .then(r => {
        fillPosLayoutData(r)
      }).finally(() => null);

  }

  const fillPosLayoutData = (data: IPosLayoutDto[]) => {
    const categoriesTemp: IPosLayoutCategory[] = [];
    const subcategoriesTemp: IPosLayoutSubCategory[] = [];
    const fieldsTemp: IPosLayoutField[] = [];


    for (let i = 0; i < data.length; i++) {
      const item: IPosLayoutDto = data[i];
      let categorieTemp: IPosLayoutCategory;
      let subcategorieTemp: IPosLayoutSubCategory;
      let fieldTemp: IPosLayoutField;

      categorieTemp = {
        'categoryID': item.categoryID,
        'category': item.category,
      }

      subcategorieTemp = {
        'categoryID': item.categoryID,
        'subCategoryID': item.subCategoryID,
        'subCategory': item.subCategory,
        'value': ""
      }

      fieldTemp = {
        'categoryID': item.categoryID,
        'subCategoryID': item.subCategoryID,
        'poS_LayoutID': item.poS_LayoutID,
        'poS_Layout': item.poS_Layout,
        'selected': false,
        'details': ''
      }

      if (!categoriesTemp.some((item) => item.categoryID === categorieTemp.categoryID)) {
        categoriesTemp.push(categorieTemp);
      }

      if (!subcategoriesTemp.some((item) => item.subCategoryID === subcategorieTemp.subCategoryID)) {
        subcategoriesTemp.push(subcategorieTemp);
      }
      fieldsTemp.push(fieldTemp)
    }
    setCategories(categoriesTemp);
    setSubcategories(subcategoriesTemp)
    setFields(fieldsTemp)

  }


  const handleChangeSelection = (e: any, categoryId: number, subcategoryId: number, posLayoutId: number) => {
    const idActual = e.target.value;

    const subcategoriesTemp = subcategories;
    const subcategory = subcategoriesTemp.find(item => item.subCategoryID === subcategoryId);

    if (subcategory) {
      if (e.target.value === subcategory.value) {

        const posLayoutDataTemp = posLayoutData.filter(item => item.categoryId !== subcategoryId);
        setPosLayoutData([...posLayoutDataTemp]);

        subcategoriesTemp.find(item => item.subCategoryID === subcategoryId)!.value = "";
        setSubcategories([...subcategoriesTemp])

      } else {

        if (posLayoutId === 2) {

          subcategoriesTemp.find(item => item.subCategoryID === subcategoryId)!.value = e.target.value;
          setSubcategories([...subcategoriesTemp])
          const posLayoutDataTemp = posLayoutData

          posLayoutDataTemp.push({
            appointmentActivityId: appointmentActivityId,
            posLayoutTypeId: posLayoutId,
            categoryId: subcategoryId,
            dateLog: new Date(),
            details: '',
            radioId: idActual
          })
          setPosLayoutData([...posLayoutDataTemp]);
          setSelectedToDetails(idActual)
          setShowModalDetails(true)

        } else {

          subcategoriesTemp.find(item => item.subCategoryID === subcategoryId)!.value = e.target.value;
          setSubcategories([...subcategoriesTemp])

          const posLayoutDataTemp = posLayoutData

          posLayoutDataTemp.push({
            appointmentActivityId: appointmentActivityId,
            posLayoutTypeId: posLayoutId,
            categoryId: subcategoryId,
            dateLog: new Date(),
            details: '',
            radioId: idActual

          })
          setPosLayoutData([...posLayoutDataTemp]);


        }

      }
    }

  }

  const handleChangeDetails = (input: string) => {
    setDetails(input)
  }
  const cancelSubmitDetails = () => {
    const subcategoriesTemp = subcategories;

    subcategoriesTemp.find(item => item.value === selectedToDetails)!.value = "";;
    setSubcategories([...subcategoriesTemp])

    const posLayoutDataTemp = posLayoutData.filter(item => item.radioId !== selectedToDetails);
    setPosLayoutData([...posLayoutDataTemp]);


    setShowModalDetails(false)
    setDetails('')
  }

  const submitValues = () => {
    let posLayoutIn: IPosLayoutIn[] = []

    posLayoutData.forEach(item => {
      posLayoutIn.push({
        appointmentActivityId: item.appointmentActivityId,
        posLayoutTypeId: item.posLayoutTypeId,
        categoryId: item.categoryId,
        dateLog: item.dateLog,
        details: item.details
      })
    })
    posLayoutService.insertPosLayout(posLayoutIn)
      .then(r => {
        setPosLayoutData([]);
        setCategories([]);
        getPosLayoutTypeByCategories();
        setShowModalSubmitConfirmation(false)
        navigate(`/activitiesByAppointment/${activityId}`);
      })

  }

  const saveDetails = () => {

    const posLayoutDataTemp = posLayoutData;
    posLayoutDataTemp.find(item => item.radioId === selectedToDetails)!.details = details;
    setPosLayoutData([...posLayoutDataTemp]);
    setShowModalDetails(false)
    setDetails('')

  }


  return (
    <>
      <div className="posLayout">
        <BackButton route={BreadCrumbsEnum.POSLayout} activityId={activityId} appointmentActivityId={appointmentActivityId} />
        <h4 className="posLayoutTitle">{t("header.posLayoutTitle")}</h4>


        <div className="posLayoutButtonSaveDiv">
          <Button className="posLayoutButtonSave" disabled={saveButtonDisable} onClick={() => setShowModalSubmitConfirmation(true)}>{t("modal.saveTitleInfo")}</Button>
        </div>

        <Card
          appearance="outlined"
          className="posLayoutCard"
          content={

            <div>
              {categories.map((category, index) =>
                <Accordion
                  key={index}
                  className="posLayoutAccordion"
                >
                  <AccordionSummary
                    expandIcon={<IconChevronDown />}
                    aria-controls="panel2a-content"
                    id="panel2a-header">
                    {category.category}
                  </AccordionSummary>
                  <AccordionDetails>
                    {subcategories.map((subcategory, indexSubcategory) =>
                      subcategory.categoryID === category.categoryID ?
                        <Accordion
                          key={indexSubcategory}
                          className="posLayoutAccordion">
                          <AccordionSummary
                            expandIcon={<IconChevronDown />}
                            aria-controls="panel2a-content"
                            id="panel2a-header">
                            {subcategory.subCategory}
                          </AccordionSummary>
                          <AccordionDetails>
                            <RadioButtons alignment="vertical" name={`radio${subcategory.subCategoryID}`} value={subcategory.value}>
                              {
                                fields.map((field, indexField) =>
                                  field.subCategoryID === subcategory.subCategoryID && field.categoryID === category.categoryID ?
                                    <RadioButton id={category.categoryID + "-" + subcategory.subCategoryID + "-" + field.poS_LayoutID} value={category.categoryID + "-" + subcategory.subCategoryID + "-" + field.poS_LayoutID} label={field.poS_Layout} onClick={(e) => handleChangeSelection(e, category.categoryID, subcategory.subCategoryID, field.poS_LayoutID)} /> : <></>
                                )
                              }

                            </RadioButtons >
                          </AccordionDetails>

                        </Accordion> : null

                    )}
                  </AccordionDetails>

                </Accordion>

              )}
            </div>



          }
        />


        <div style={{ position: 'relative' }}>
          <Modal
            align="center"
            id="modalSubmitConfirmation"
            show={showModalSubmitConfirmation}
            onClose={() => setShowModalSubmitConfirmation(false)}
            footer={(
              <ButtonGroup className="submitConfirmationButtongrouop">
                <Button onClick={submitValues}>{t("header.yes")}</Button>
                <Button onClick={() => setShowModalSubmitConfirmation(false)} appearance="secondary">{t("header.cancel")}</Button>
              </ButtonGroup>
            )}
            title={t("modal.saveTitleInfo")}
          >
            <p>
              {t("modal.saveMessage")}
            </p>
          </Modal>
        </div>


        <div style={{ position: 'relative' }}>
          <Modal
            align="center"
            id="modalDetails"
            show={showModalDetails}
            onClose={cancelSubmitDetails}
            footer={(
              <ButtonGroup className="submitConfirmationButtongrouop">
                <Button onClick={saveDetails}>{t("header.save")}</Button>
                <Button onClick={cancelSubmitDetails} appearance="secondary">{t("header.cancel")}</Button>
              </ButtonGroup>
            )}
            title={t("header.notApplicable")}
          >
            <p>
              {t("header.justifyNotApplicable")}
            </p>
            <TextArea
              value={details}
              onChange={handleChangeDetails}
            />
          </Modal>
        </div>

      </div>
    </>
  );
}